module.exports = __webpack_public_path__ + "img/秒杀专场.58890a4f.png";